import { useCallback } from 'react'
import { LeadAssignmentRuleFormModel } from '../../../../typings'
import { useFormikContext } from 'formik'
import { AssigneeOption } from '@user/store/salesTeam'

type Props = {
  name: string
}

export function useHandlers(props: Props) {
  const { name } = props
  const { setFieldValue } = useFormikContext<LeadAssignmentRuleFormModel>()

  const handleChange = useCallback(
    (value: AssigneeOption[] | null) => {
      setFieldValue(name, value?.map((x) => x.id) ?? [])
    },
    [setFieldValue, name],
  )
  return {
    handleChange,
  }
}
